/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Link } from '@material-ui/core';
import AddchartIcon from '@mui/icons-material/Addchart';
import HomeIcon from '@mui/icons-material/Home';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HistoryIcon from '@mui/icons-material/History';
import GavelIcon from '@mui/icons-material/Gavel';

import style from './style';

function FooterAtom(props) {
  const classes = style();
  // const user = localStorage.getItem("user");
  const user = JSON.parse(localStorage.getItem("user"));
  const isDealer = props.isDealer;
  const [isActive, SetIsActive] = useState(props.active);

  // const Active = (index) => {
  //   isActive.fill(0);
  //   isActive[index] = 1;
  // }

  // useEffect(() => {
  //   if(props && props.index)
  //     Active(props.index);
  // }, []);

  return (
    <>
      <Box className={`${classes.contetnArrange}`}>
        <Link href="/marketView">

          <StorefrontIcon style={{ fill: isActive[0] ? "#53252f" : 'gray' }} />
          <Typography variant="caption">
            मंडी
          </Typography>
        </Link>
        {isDealer ?
          <Link href="/repeatUser">
            <AddCircleOutlineIcon style={{ fill: isActive[1] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              नया सौदा
            </Typography>
          </Link> : <Link>
            <AddCircleOutlineIcon style={{ fill: isActive[1] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              नया सौदा
            </Typography>
          </Link>}
        {isDealer ?
          <Link href="/mydeals">
            <HistoryIcon style={{ fill: isActive[2] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              मेरे सौदे
            </Typography>
          </Link> :
          <Link>
            <HistoryIcon style={{ fill: isActive[2] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              मेरे सौदे
            </Typography>
          </Link>}
        {isDealer ?
          <Link href="/mybids">
            <GavelIcon style={{ fill: isActive[3] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              मेरी बोलियां
            </Typography>
          </Link> :
          <Link>
            <GavelIcon style={{ fill: isActive[3] ? "#53252f" : 'gray' }} />
            <Typography variant="caption">
              मेरी बोलियां
            </Typography>
          </Link>}
      </Box>
    </>

  );
}

export default FooterAtom;